/* ============================================================
   Maison Sillage · collection-filter
   Client-side Draagtijd-filter voor de collectie. App-vrij:
   filtert de zichtbare .pcard's op hun data-draagtijd tegen de
   gekozen chip. De matchbeslissing is een pure functie zodat
   'ie los te unit-testen is (tests/collection-filter.test.js).

   Let op (schaal): dit filtert de HUIDIGE pagina. Bij een grote
   catalogus met paginatie is Shopify's native facet-filter
   (collection.filters via Search & Discovery) de opvolger.
   ============================================================ */
(function (root, factory) {
  "use strict";
  var api = factory();
  if (typeof module === "object" && module.exports) { module.exports = api; }
  if (root) { root.OS = root.OS || {}; root.OS.draagtijdMatches = api.draagtijdMatches; root.OS.normDraagtijd = api.normDraagtijd; }
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";

  // Haal de uren-cijfers uit een draagtijd-waarde: "48 uur" / "48u" / "48" -> "48". Leeg/geen cijfer -> "".
  function normDraagtijd(v) {
    if (v == null) return "";
    var m = String(v).match(/\d+/);
    return m ? m[0] : "";
  }

  // Matcht de draagtijd van een kaart tegen een filterwaarde. Filter "all" of leeg toont alles.
  function draagtijdMatches(cardValue, filterValue) {
    if (filterValue == null || String(filterValue).toLowerCase() === "all") return true;
    var f = normDraagtijd(filterValue);
    if (f === "") return true;
    return normDraagtijd(cardValue) === f;
  }

  function initCollectionFilter() {
    var chips = document.querySelectorAll("[data-draagtijd-filter]");
    if (!chips.length) return;

    function apply(filterValue) {
      var cards = document.querySelectorAll(".pcard");
      Array.prototype.forEach.call(cards, function (card) {
        var show = draagtijdMatches(card.getAttribute("data-draagtijd"), filterValue);
        card.style.display = show ? "" : "none";
      });
    }

    Array.prototype.forEach.call(chips, function (chip) {
      chip.addEventListener("click", function (e) {
        e.preventDefault();
        Array.prototype.forEach.call(chips, function (c) { c.classList.remove("active"); });
        chip.classList.add("active");
        apply(chip.getAttribute("data-draagtijd-filter"));
      });
    });
  }

  // In de browser: wire na het laden. In node (require voor de tests): geen document -> alleen de pure functies.
  if (typeof document !== "undefined") {
    document.addEventListener("DOMContentLoaded", initCollectionFilter);
  }

  return { draagtijdMatches: draagtijdMatches, normDraagtijd: normDraagtijd };
});
